import React, { useCallback, useEffect } from 'react';
import { Translate, withLocalize } from 'react-localize-redux';
import { useQuery } from '@apollo/client';
import { useNavigate } from 'react-router-dom';
import css from './ExtractDataDestinationsPage.css';
import Button from '../../components/atoms/Button';
import ExtractLogo from '../../resources/svg/extract_data_destinations/extract_logo.svg';
import ExtractBackground from '../../resources/svg/extract_data_destinations/extract_background.svg';
import { GET_EXTRACT_DATA_DESTINATIONS_OPTIONS } from '../queries';
import FeaturesSection from '../../components/organisms/FeaturesSection';

const EXTRACT_DEMO_VIDEO = 'https://www.extract.to/wp-content/uploads/2025/04/Extract_hero_video_1MB.mp4';
const EXTRACT_LOGIN_URL = 'https://app.singular.net/extract/login';

const FEATURES = [
    {
        iconName: 'adjustments',
        translationKey: 'FULL_VISIBILITY',
        iconBackgroundColor: 'var(--gray150)',
    },
    {
        iconName: 'brand-speedtest',
        translationKey: 'RUST_POWERED',
        iconBackgroundColor: 'var(--gray150)',
    },
    {
        iconName: 'square-plus-2',
        translationKey: 'UNIFIED_GROWTH',
        iconBackgroundColor: 'var(--gray150)',
    },
    {
        iconName: 'gift',
        translationKey: 'FREE_ROWS',
        iconBackgroundColor: 'var(--gray150)',
    },
];

function ExtractDataDestinationsPage() {
    const navigate = useNavigate();
    const { data: organizationOptions, loading } = useQuery(GET_EXTRACT_DATA_DESTINATIONS_OPTIONS);
    const extractDataDestinationsEnabled = organizationOptions?.extractDataDestinationsEnabled ?? true;

    const handleGoToExtract = useCallback(() => {
        const newWindow = window.open('about:blank', '_blank');
        if (!newWindow) {
            window.alert('Please enable popup windows and retry');
            return;
        }
        newWindow.opener = null;
        newWindow.location.href = EXTRACT_LOGIN_URL;
        newWindow.focus();
    }, []);

    useEffect(() => {
        if (!loading && !extractDataDestinationsEnabled) {
            navigate('/react/data-destinations');
        }
    }, [loading, extractDataDestinationsEnabled, navigate]);

    if (loading || !extractDataDestinationsEnabled) {
        return null;
    }

    return (
        <div className={css.container}>
            <div className={css.headerSection}>
                <div className={css.leftContent}>
                    <div className={css.title}>
                        <ExtractLogo className={css.extractLogo} />
                        <Translate id="STATIC.PAGES.EXTRACT_DATA_DESTINATIONS.TITLE" />
                    </div>
                    <div className={css.description}>
                        <Translate id="STATIC.PAGES.EXTRACT_DATA_DESTINATIONS.DESCRIPTION" />
                        <Button className={css.actionButton} onClick={handleGoToExtract}>
                            <Translate id="STATIC.PAGES.EXTRACT_DATA_DESTINATIONS.GO_TO_EXTRACT" />
                        </Button>
                    </div>
                </div>
                <div className={css.extractBackgroundWrapper}>
                    <ExtractBackground className={css.extractBackground} />
                    <video className={css.extractDemoVideo} src={EXTRACT_DEMO_VIDEO} autoPlay muted loop playsInline />
                </div>
            </div>
            <FeaturesSection
                features={FEATURES}
                pageName="PAGES.EXTRACT_DATA_DESTINATIONS"
                numberColumns={2}
                featuresSectionClass={css.featuresSection}
                featuresCardClass={css.featureCard}
            />
        </div>
    );
}

export default withLocalize(ExtractDataDestinationsPage);
